import { Module, getModule, VuexModule, MutationAction, Mutation } from 'vuex-module-decorators';
import store from '@/store';
import { FilterRequestType } from '@/entity/common/filters.types'
import { IProductsTaxSystemItem } from '@/entity/warehouse/Products/TaxSystem/TaxSystem.types'

@Module({
    namespaced: true,
    name: 'ProductsTaxSystem',
    store,
    dynamic: true
})
class ProductsTaxSystemModule extends VuexModule {
    public productsTaxSystem:IProductsTaxSystemItem[] | null = null
    ready = false

    @MutationAction
    async fetchAll(data?: FilterRequestType): Promise<{ productsTaxSystem:IProductsTaxSystemItem[]}>{
        const formData = new FormData();
        if (data) {
            if (data.filter) {
                for(const field in data.filter){
                    Object.keys(data.filter).forEach(field => formData.append('filter[' + field + ']', data.filter[field].toString()));
                }
            } else formData.delete('filter');
        }
        const productsTaxSystem = await store.$repository.products_taxsystem.fetchAll(formData);
        return { productsTaxSystem }
    }
    @Mutation
    async setReady(st:boolean){
        this.ready = st
    }

}
export const ProductsTaxSystemStore = getModule(ProductsTaxSystemModule)